import { Typography } from '@mui/material';

import { MISSING_DATA_PLACEHOLDER } from './constants';
import { FORTA_GRAY3 } from '../../../../../utils/colors';

interface ICOReadOnlyTextFieldProps {
  value: string | null;
}

function COReadOnlyTextField({ value }: ICOReadOnlyTextFieldProps) {
  return value === null ? (
    <Typography textAlign="left" color={FORTA_GRAY3}>
      {MISSING_DATA_PLACEHOLDER}
    </Typography>
  ) : (
    <Typography textAlign="left">{value}</Typography>
  );
}

export default COReadOnlyTextField;
